module.exports = __webpack_public_path__ + "img/B2674B_552913_7C442F_733919-256px.9c8cab1e.png";